import React, { Component } from 'react';
import '../Modal.css';
import './ModalStart.css';
import reelSVG from '../../../shared/assets/modals/reel.svg';

class ModalStart extends Component {
  render() {
    if (!this.props.show) {
      return null;
    }
    return (
      <div>
        <div className='backdrop' />
        <div className='modal start-container'>
          <img className='reel' src={reelSVG} alt='film reel'/>
          <h1 className='modal-title start-title'>Animatic</h1>
          <p className='start-text'>Organize the frames in the correct sequence to reveal an animation!</p>
          <div className='button-container'>
            <button className='modal-button rule' onClick={() => {
              this.props.onRule();
            }}>Rules</button>
            <button className='modal-button play' onClick={this.props.onPlay}>Play</button>
          </div>
        </div>
      </div>
    )
  }
}

export default ModalStart;